import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-footer" }
const _hoisted_6 = { class: "button-wrapper" }

import {onMounted, ref, watch} from "vue";
import {Modal} from "bootstrap";
import {BButton} from "./../BButton";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormModal',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    width: { default: 750 },
    submitButton: { default: "Save" },
    loading: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: true }
  }, {
    "modelValue": {type: Boolean},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["submit"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const model = _useModel(__props, "modelValue");

const props = __props;

const modalFormElement = ref<HTMLElement>();
const triggerElement = ref<HTMLElement | null>(null);
let modelObject: Modal;

const emit = __emit;

onMounted(() => {
    modelObject = new Modal(modalFormElement.value!);

    modalFormElement.value!.addEventListener("hidden.bs.modal", (event) => {
        model.value = false;

        if (triggerElement.value?.isConnected) {
            triggerElement.value.focus();
        }
        triggerElement.value = null;
    });
});

const submit = function () {
    emit("submit");
};

function _show() {
    triggerElement.value = document.activeElement as HTMLElement | null;
    modelObject.show();
    model.value = true;
}

function _hide() {
    modelObject.hide();
    model.value = false;
}

watch(
    () => model.value,
    (showModal, prevShowModal) => {
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    "data-bs-backdrop": "static",
    tabindex: "-1",
    "aria-label": __props.title,
    ref_key: "modalFormElement",
    ref: modalFormElement
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", {'modal-dialog-scrollable': __props.scrollable}]),
      style: _normalizeStyle({maxWidth: `${__props.width}px`})
    }, [
      _createElementVNode("form", {
        class: "modal-content",
        novalidate: "",
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.title), 1),
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(BButton), {
              variant: "secondary",
              "data-bs-dismiss": "modal",
              type: "button"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Cancel ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_unref(BButton), {
              variant: "primary",
              loading: __props.loading,
              type: "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.submitButton), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ], 32)
    ], 6)
  ], 8, _hoisted_1))
}
}

})